// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__20-h5","alert":"SettungsInbox_alert__1ChQ9"};